import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThread"><Path d="M13.937 3H20V5H19V9.65287L5 7.31954V5H4V3H10.063C10.285 2.13739 11.0681 1.5 12 1.5C12.9319 1.5 13.715 2.13739 13.937 3Z" fill="currentColor"/><Path d="M10.063 20.9996H4V18.9996H5V14.3467L19 16.68V18.9996H20V20.9996H13.937C13.715 21.8622 12.9319 22.4996 12 22.4996C11.0681 22.4996 10.285 21.8622 10.063 20.9996Z" fill="currentColor"/><Path d="M5 12.3191V9.34668L19 11.68V14.6524L5 12.3191Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThread;
